export default {
    ledium_title: 'Ledium MEC',
    logout_user: 'Kijelentkezés {0}',

    dashboard_title: 'Vezérlőpult',
    dashboard_description: 'Ez a Projekt Vezérlőközpont. A Projekt szerkesztőben létrehozott projekteket itt indíthatja el, állíthatja le és szüneteltetheti.',

    dli: 'DLI',
    dli_unit: 'mol/m²/nap',
    dli_total_unit: 'mol/m²',
    dli_current_section_day: 'Jelenlegi szakasz napja',
    dli_sum_all_sections: 'Összes szakasz összege',

    project_editor_title: 'Projekt szerkesztő',
    project: 'Projekt',
    project_description: 'Itt párosíthatja a Spektrum Mixeket az eredeti Fényreceptekhez.',
    no_project: 'Nincs még projekt.',
    search_for_project: 'Projekt keresése',
    project_running_lock: 'Futó projektet nem lehet módosítani vagy törölni',
    project_editor_recipe_info: 'A recept {0} egyedi fényreceptet használ.',
    project_editor_missing_light_recipes:
        'A növekedési recept nem tartalmaz egyetlen fényreceptet sem a cirkadián beállításokban. Valószínűleg egy befejezetlen receptet próbál használni.',
    no_recipe_selected: 'Nincs recept kiválasztva',
    project_linked_spektrum_mix: 'A spektrum mixet nem lehet kiválasztani, mert a "{0}" projekt használja.',
    project_editor_select_spektrum_mix: 'Válasszon spektrum mixet a "{0}" fényrecepthez',
    do_you_want_to_stop_the_project: 'Biztosan le szeretné állítani a projektet?',
    original_light_recipe: 'Eredeti fényrecept',
    mixed_spectrum: 'Kevert spektrum',
    intensity: 'Intenzitás',
    value: 'Érték',
    one_bit_on: 'ON',
    one_bit_off: 'OFF',
    jump_back: 'Visszaugrás a(z) {0}. szakasz {1}. cirkádiánjára',
    jump_forward: 'Előreugrás a(z) {0}. szakasz {1}. cirkádiánjára',
    restart_current_circadian: 'Jelenlegi cirkadián újraindítása',

    zone_device_management: 'Eszköz beállítások',

    light_channels_title: 'Fénycsatornáim',
    light_channel: 'Fénycsatorna',
    light_channel_description: 'Elérhető LED fénycsatornák. Fénycsatornákat itt adhat hozzá, szerkeszthet és törölhet.',
    no_light_channel: 'Nincs még fénycsatorna.',
    search_for_light_channel: 'Fénycsatorna keresése',
    select_light_channel: 'Válasszon fénycsatornát',
    light_channel_running_project: 'A fénycsatornát egy futó projekt használja: {0}',
    light_channel_linked_project: 'A fénycsatornát a(z) "{0}" spektrum mix használja a(z) "{1}" projekthez, ezért nem törölhető.',
    light_channel_used_in_mix: 'A fénycsatornát a(z) "{0}" spektrum mix használja, ezért nem törölhető.',
    light_channel_details: 'DMX csatorna: {0}, {1} bit',
    resolution: 'Felbontás',
    X_bit: '{0} bit',
    intensity_value_X_to_Y: 'Intenzitás ({0} - {1})',
    you_should_upload_a_valid_spectrogram_csv_file_before_save: 'Mentés előtt töltsön fel egy érvényes spektrogram CSV fájlt.',
    test_channel: 'Csatorna tesztelése',
    search_next_free_channel: 'Szabad DMX csatorna keresése',
    next_free_channel_can_not_allocate: 'Nem található szabad csatorna {0} bites felbontáshoz!',
    next_free_channel_found: 'Megtalálva a legalacsonyabb szabad csatorna {0} bites felbontáshoz.',
    dmx_channel: 'DMX csatorna',
    dmx_channel_X_to_Y: 'DMX csatorna ({0}-{1})',
    dmx_channel_channel_info: 'A {0} bites felbontás {1} egymást követő csatornát használ ({2}. csatornától {3}. csatornáig)',
    dmx_channel_channel_conflict:
        'Nincs {0} szabad egymást követő csatorna a(z) {1}. csatornától kezdve. Más kezdőcsatornát megadhat kézzel, vagy a "Szabad DMX csatorna keresése" gombbal.',
    bit: 'bit',

    spektrum_mixer_title: 'Spektrum mixer',
    spektrum_mix: 'Spektrum mix',
    spektrum_mixer_description: 'Spektrum mixet hozhat létre az elérhető fénycsatornáiból, amely szimulálja a fényreceptet.',
    no_spektrum_mix: 'Még nincs spektrum mix.',
    search_for_spektrum_mix: 'Spektrum mix keresése',
    spektrum_mix_running_project: 'A spektrum mixet egy futó projekt használja: {0}',
    spektrum_mix_linked_project: 'A spektrum mixet a(z) "{0}" projekt használja, ezért nem törölhető',
    spektrum_mix_linked_light_channel_another_mix:
        'Nem választható ki, a fénycsatorna hozzá van adva a(z) "{0}" spektrum mixhez, amelynek van a(z) "{1}" projekthez kapcsolódó fénycsatornája',
    spektrum_mix_linked_light_channel_project: 'Nem választható ki, a fénycsatornát a(z) "{0}" projekt használja',
    spektrum_mix_realtime_lights: 'Valósidejű világítás',
    add_new_spektrum_mix_button: 'Új spektrum mix hozzáadása',

    zone_manage_projects: 'Projektek kezelése',

    recipes_title: 'Növekedési receptek',
    recipe: 'Recept',
    save_recipe: 'Növekedési recept mentése',
    recipe_description: 'A növekedési periódusokhoz különböző szakaszokat hozhat létre, fényrecepteket adva egy idővonalhoz.',
    no_recipe: 'Még nincs növekedési recept',
    search_for_recipe: 'Növekedési recept keresése',
    select_recipe: 'Recept kiválasztása',
    recipe_linked_project: 'A receptet legalább egy projekt használja, nem törölhető',
    recipe_locked_project: 'A receptet legalább egy futó projekt használja, nem módosítható',
    recipe_section_saved_info: 'A szakasz frissítve, de a recept még nincs elmentve!',
    add_new_section_button: 'Új szakasz hozzáadása',
    new_section_temporary_name: 'ÚJ SZAKASZ',
    add_new_light_event_button: 'Új fényesemény hozzáadása',
    delete_circadian_event_title: 'Cirkadián esemény törlése',
    delete_circadian_event_message: 'Törli ezt a cirkadián eseményt?',
    event_time: 'Esemény: {0}:{1}',
    circadian_length_hours: 'óra',
    save_section: 'Szakasz mentése',
    delete_section_title: 'Szakasz törlése',
    delete_section_message: 'Törli ezt a szakaszt?',
    discard_section_changes_title: 'Változtatások elvetése',
    discard_section_changes_message: 'Mentetlen változtatások vannak. Elveti őket?',
    unsaved_changes_title: 'Mentetlen változtatások',
    unsaved_changes_message: 'Mentetlen változtatások vannak. Ha elhagyja az oldalt, a változtatások elvesznek.',
    leave_page: 'Elhagyás',
    stay_on_page: 'Maradás',
    circadian_repeat_time: 'Ismétlési idő',
    section_timeline_info: 'Az idővonal mindig 24 órás formátumban van, a futási idő arányosan igazodik a cirkadián hosszához.',
    circadian_length: 'Cirkadián hossza',
    select_section_background_color: 'Szín kiválasztása a szakaszhoz',
    sed: 'SED',
    hours: 'Óra',

    light_recipes_title: 'Fényreceptek',
    light_recipe: 'Fényrecept',
    light_recipe_description:
        'Spektrogramokat tölthet fel vagy rajzolhat itt. A vezérlő a legjobb tudása szerint szimulálja ezeket a fényrecepteket az elérhető LED fénycsatornáival.',
    no_light_recipe: 'Még nincs fényrecept.',
    search_for_light_recipe: 'Fényrecept keresése',
    light_recipe_running_project: 'A fényreceptet legalább egy futó projekt használja, nem módosítható',
    light_recipe_linked_project: 'A fényreceptet legalább egy projekt használja, nem törölhető',
    light_recipe_csv_upload_title: 'Biztos benne?',
    light_recipe_csv_upload_message: 'A feltöltött CSV felülírja a meglévő spektrumot',
    light_recipe_download_csv: 'Spektrogram letöltése CSV-ben',
    download_spectrum_csv: 'Spektrogram letöltése CSV-ben',

    add_new_project: 'Új projekt hozzáadása',
    start_project: 'Projekt indítása',
    project_started: 'A projekt sikeresen elindult.',
    stop_project: 'Projekt leállítása',
    stop_all_running_projects: 'Összes futó projekt leállítása',
    stop_all_running_confirm: '{0} projekt fut jelenleg. Biztosan le szeretné állítani {0,choice,0#az összeset|1#azt|1<az összeset}?',
    project_stopped: 'A projekt sikeresen leállt.',
    pause_project: 'Projekt szüneteltetése',
    resume_project: 'Projekt folytatása',
    project_paused: 'A projekt sikeresen szünetel.',
    project_resumed: 'A projekt folytatódik.',
    project_detailed_status: '{0} szakasz fut, {3}%-nál tart {1,choice,0#a|1#az|2#a|3#a|4#a|5#az|5<a} {1}. nap a {2} közül',
    project_is_running_for: 'A projekt {0} óta fut',
    project_is_paused_at: 'A projekt szüneteltetve {0}-nál.',

    are_you_sure: 'Biztos benne?',
    do_you_want_to_delete_X: 'Törli a(z) "{0}" elemet?',
    do_you_want_to_duplicate_X: 'Megduplázza a(z) "{0}" elemet?',
    X_is_successfully_duplicated: '{0} sikeresen megduplázva',
    something_went_wrong: 'Valami hiba történt...',

    name: 'Név',
    add_new: 'Új hozzáadása',
    view: 'Megtekintés',
    edit: 'Szerkesztés',
    edit_zone: 'Zóna szerkesztése',
    details: 'Részletek',
    duplicate: 'Másolás',
    delete: 'Törlés',
    save: 'Mentés',
    cancel: 'Mégse',
    ok: 'Ok',

    you_can_change_the_order_of_the_sections_by_drag_n_drop: 'A szakaszok sorrendjét húzd és ejtsd (drag & drop) módszerrel változtathatja.',
    spectral_energy_density: 'Spektrális energiasűrűség',
    sum_intensity: 'Mix intenzitás: {0} µmol/s/m2',
    original_light_recipe_intensity: 'Eredeti fényrecept intenzitás:',
    intensity_unit: 'Intenzitás',
    wave_length_intensity: 'Hullámhossz intenzitás',
    target_wave_length_intensity: 'Cél hullámhossz intenzitás',
    editing_light_recipe: 'Fényrecept szerkesztése',
    X_is_successfully_added: '{0} sikeresen hozzáadva',
    X_is_successfully_updated: '{0} sikeresen frissítve',
    load_item_failed: 'Az elem betöltése sikertelen.',
    unable_to_save_the_data: 'Az adatokat nem sikerült menteni.',

    description: 'Leírás',
    no_description: 'Nincs leírás',
    select_light_recipe: 'Válasszon fényreceptet',
    no_light_recipe_selected: 'Nincs kiválasztott fényrecept',

    upload_csv_file: 'CSV fájl feltöltése',
    csv_file_is_successfully_uploaded: 'A CSV fájl sikeresen feltöltve',
    could_not_parse_spectrogram_data_in_the_uploaded_CSV_file: 'Nem sikerült a spektrogram adatokat beolvasni a feltöltött CSV fájlból!',

    login_successful: 'Sikeres bejelentkezés',
    login_failed: 'Sikertelen bejelentkezés',
    login_name: 'Felhasználónév',
    password: 'Jelszó',
    sign_in: 'Bejelentkezés',

    // item errors
    spektrum_mix_not_exists: 'A párosított spektrum mix már nem elérhető',
    spektrum_mix_not_available: 'Nincs spektrum mix létrehozva egy fényrecepthez',
    spektrum_mix_not_set: 'Egy fényrecepthez nincs párosított spektrum mix',
    target_spektrum_not_exists: 'A hozzáadott receptben szereplő fényreceptek egyike már nem elérhető',
    recipe_not_set: 'A projekthez nincs recept beállítva',
    recipe_not_exists: 'A hozzáadott recept már nem elérhető',

    // form errors
    this_field_is_required: 'Ez a mező kötelező',
    invalid_number: 'Érvénytelen szám',
    the_value_must_be_positive: 'Az értéknek pozitívnak kell lennie',
    the_value_should_be_minimum_X: 'Az érték minimuma {0} lehet',
    the_value_should_be_maximum_X: 'Az érték maximuma {0} lehet',
    the_name_should_be_unique_X_is_already_used: 'A névnek egyedinek kell lennie. A(z) {0} már foglalt.',

    settings: 'Beállítások',
    settings_description: 'Alkalmazás beállítások és frissítés',
    zone_settings: 'Beállítások',
    update_to_version: 'Frissítés {0} verzióra',
    update_in_progress: '{0}%, {1}kb/sec, ETA: {2}s',
    update_downloaded: 'A frissítés letöltve.',
    installing_update: 'Frissítés telepítése...\nEz néhány percet vehet igénybe.\nNe frissítse az oldalt.',
    no_update_available: 'Nincs elérhető frissítés',
    searching_for_update: 'Frissítés keresése...',
    enable_nightly_build_installs: 'Nightly build telepítések engedélyezése',
    application_version: 'Alkalmazás verzió: {0}',
    offline_mode: 'Offline mód',
    offline_mode_description: 'Letiltja az online funkciókat és lehetővé teszi a rendszeróra kézi beállítását.',
    offline_mode_online_warning: 'Nem ajánlott az offline módot bekapcsolni, ha az eszköznek aktív internetkapcsolata van.',
    offline_mode_enabled: 'Offline mód engedélyezése',
    set_date_and_time: 'Dátum és idő beállítása',
    set_date_and_time_description: 'A rendszeróra manuális beállítása.',
    set_date_and_time_cta: 'Dátum és idő beállítása',
    date_time_set: 'Dátum és idő beállítva: {0} {1}',
    year: 'Év',
    month: 'Hónap',
    day: 'Nap',
    hour: 'Óra',
    minute: 'Perc',
    second: 'Másodperc',
    am_pm: 'DE/DU',
    serial_number: 'Sorozatszám',
    device_name: 'Eszköznév',
    device_name_description: 'Az eszköz ember által olvasható neve.',
    device_name_label: 'Eszköznév',
    device_name_rename: 'Eszköz átnevezése',
    device_name_saved: 'Eszköznév mentve',
    software_update: 'Szoftverfrissítés',
    change_password: 'Jelszó módosítása',
    current_password: 'Jelenlegi jelszó',
    new_password: 'Új jelszó',
    confirm_password: 'Jelszó megerősítése',
    password_incorrect: 'A jelenlegi jelszó helytelen',
    password_changed: 'A jelszó megváltozott',
    wifi_ap_settings: 'WiFi hozzáférési pont beállítások',
    wifi_ap_ssid: 'SSID',
    wifi_ap_passphrase: 'Jelszó',
    wifi_ap_updated: 'WiFi hozzáférési pont beállítások frissítve',
    wifi_ap_ssid_invalid: 'Az SSID 1–32 karakter hosszú lehet (betűk, számok, szóközök, - . _)',
    wifi_ap_passphrase_invalid: 'A jelszónak 8–63 karakter hosszúnak kell lennie (betűk, számok, általános szimbólumok)',
    reboot: 'Újraindítás',
    shutdown: 'Leállítás',
    reboot_confirm: 'Biztosan újra szeretné indítani az eszközt?',
    shutdown_confirm: 'Biztosan le szeretné állítani az eszközt?',
    power_management: 'Energiagazdálkodás',
    helper_unavailable_warning:
        'Néhány funkció nem érhető el, mert az eszközön nincs telepítve egy szükséges rendszerkomponens. Az alább jelölt szekciók le vannak tiltva.',
    server_offline_warning: 'Az eszköznek nincs internetkapcsolata. Az alább jelölt szekciók le vannak tiltva.',
    power_management_description: 'Indítsa újra vagy állítsa le az eszközt. A rendszer leállítás előtt biztonságosan befejezi az összes futó folyamatot.',
    rebooting: 'Az eszköz újraindul...',
    shutting_down: 'Az eszköz leáll...',
    software_update_description:
        'Alkalmazásfrissítések keresése és telepítése. Az új verziók kereséséhez az eszköznek internet-hozzáféréssel kell rendelkeznie.',
    change_password_description: 'Módosítsa a fiókjához tartozó jelszót.',
    export_database: 'Adatbázis exportálása',
    export_database_description: 'Töltse le az összes adatbázisfájl zip archívumát biztonsági mentési vagy migrációs célokra.',
    export_database_download: 'Adatbázis exportálás letöltése',
    import_database: 'Adatbázis importálása',
    import_database_description:
        'Adatbázisfájlok visszaállítása egy korábban exportált zip archívumból. Az összes futó projekt leáll, és a jelenlegi adatok felülíródnak.',
    import_database_drop_or_select: 'Húzza ide az adatbázis export .zip fájlt, vagy kattintson a kiválasztáshoz',
    import_database_upload: 'Importálás',
    import_database_success: 'Az adatbázis sikeresen importálva',
    import_database_error_no_file: 'Nincs fájl kiválasztva',
    import_database_error_missing_checksum: 'A fájl nem tartalmaz ellenőrzőösszeget',
    import_database_error_hash_mismatch: 'A fájl integritás-ellenőrzése sikertelen — a fájl sérült lehet, vagy nem ezzel az alkalmazással lett exportálva',
    import_database_error_invalid_filename: 'Érvénytelen fájlnév — kérjük, használjon ezzel az alkalmazással exportált fájlt',
    import_database_error_invalid_zip_contents: 'Érvénytelen adatbázis állomány',
    import_database_error_unknown: 'Az importálás sikertelen',
    cloud_backup: 'Felhő biztonsági mentés',
    cloud_backup_description:
        'Ha engedélyezve van, az adatok óránként automatikusan mentésre kerülnek a felhőbe. A mentett adatokat a Felhő importálás menüből állíthatja vissza.',
    cloud_backup_enabled: 'Felhő biztonsági mentés engedélyezése',
    cloud_restore: 'Felhő visszaállítás',
    cloud_restore_description: 'Korábban mentett biztonsági mentés betöltése a felhőből.',
    cloud_restore_open: 'Felhő mentések megnyitása',
    cloud_restore_no_backups: 'Nem található mentés.',
    cloud_restore_col_version: 'Verzió',
    cloud_restore_col_date: 'Dátum',
    cloud_restore_cta: 'Visszaállítás',
    cloud_restore_version_mismatch: 'Eltérő verzió a jelenlegitől',
    cloud_restore_confirm_title: 'Biztonsági mentés visszaállítása',
    cloud_restore_confirm_message: 'Biztosan visszaállítja a(z) {0} verzióból, {1}-én mentett biztonsági mentést? Ez felülírja az aktuális adatait.',
    wifi_ap_settings_description:
        'Konfigurálja a beépített WiFi hozzáférési pontot. A változtatások azonnal érvénybe lépnek, és az összes WiFi klienst újracsatlakoztatják.',
    tab_application: 'Alkalmazás',
    tab_backup: 'Mentés',
    tab_user: 'Felhasználó',
    tab_system: 'Rendszer',

    date_and_time: 'Dátum és idő',
    date_and_time_description: 'Állítsa be, hogyan jelenjenek meg a dátumok és időpontok az alkalmazásban.',
    date_format: 'Dátumformátum',
    date_format_ymd: 'ÉÉÉÉ-HH-NN',
    date_format_mdy: 'HH/NN/ÉÉÉÉ',
    date_format_dmy: 'NN/HH/ÉÉÉÉ',
    time_format: 'Időformátum',
    time_format_24: '24 órás formátum',
    time_format_12: '12 órás formátum (DE/DU)',
    save_changes: 'Változtatások mentése',
    date_time_format_saved: 'Dátum és idő formátum mentve',

    zones_title: 'Csoportok',
    zone: 'Csoport',
    zones_description: 'Szervezd lámpaeszközeidet zónákba – szobákba, növénysátrakba, klímakamrákba vagy bármilyen fizikai térbe',
    zone_selector_edit_info:
        'Válassz egy zónát a szerkesztéshez vagy törléshez. Húzással rendezheted át vagy ágyazhatod egymásba a zónákat. Eszközöket tartalmazó zónák nem lehetnek szülők. A Másolás és Kapcsolás funkcióval tükrözött vagy független másolatot hozhatsz létre.',
    no_zone: 'Még nincs csoport',
    search_for_zone: 'Csoportok keresése',
    zone_or_place_of_the_lighting_device: 'Fénycsatorna csoportja vagy helye:',
    parent_zone: 'Szülő csoport:',
    change_parent: 'Szülő módosítása',
    copy: 'Másolás',
    back: 'Vissza',
    next: 'Tovább',
    copy_zone_wizard_title: 'Projekt másolása / kapcsolás',
    copy_zone_step1_label: 'Mi ez?',
    copy_zone_step2_label: 'Forgatókönyv',
    copy_zone_step3_label: 'Név',
    copy_zone_step4_label: 'Csatornák',
    copy_zone_step5_label: 'Összefoglaló',
    copy_zone_step1_description: 'Ez a varázsló az alábbi módokon teszi lehetővé egy meglévő zóna újrahasznosítását:',
    copy_zone_copy_description:
        'Teljesen független másolatot hoz létre. A fénycsatornák új DMX-címekkel klónozódnak. A spektrummixek klónozódnak, csatornahivatkozásaik frissülnek. A növekedési recept és a fényreceptek megosztva maradnak.',
    copy_zone_step1_note: 'A rendszer az utolsó lépés visszaigazolásáig nem ment el semmilyen változást.',
    copy_zone_step2_heading: 'Hogyan szeretné újra felhasználni ezt a zónát?',
    copy_zone_copy_sublabel: 'Teljesen független másolatot hoz létre.',
    copy_zone_link_sync_label: 'Kapcsolat — Szinkron tükör',
    copy_zone_link_sync_sublabel: 'A zónák szinkronban működnek; egyszerre vezérelhetők.',
    copy_zone_link_independent_label: 'Kapcsolat — Független',
    copy_zone_link_independent_sublabel: 'A zónák megosztják az ütemtervet, de külön indíthatók/leállíthatók.',
    copy_zone_coming_soon: 'Hamarosan',
    copy_zone_confirm: 'Másolat létrehozása',
    copy_zone_success: 'Zóna sikeresen másolva.',
    copy_zone_step3_description: 'Ez a folyamat egy új, független zónát hoz létre. A folytatáshoz adj meg egy nevet.',
    copy_zone_step3_name_label: 'Új zóna neve',
    copy_zone_step4_search_free: 'Szabad DMX-csatornák keresése',
    copy_zone_step4_description:
        'Rendelj új DMX-címet minden, ebben a zónában használt fénycsatornához. A teszt gombbal ellenőrizheted a csatornát az új címen.',
    copy_zone_step5_description:
        "A 'Másolat létrehozása' gombra kattintva új zóna, új projekt, új fénycsatorna-másolatok és új spektrummix-másolatok jönnek létre. Minden új elem az új zóna nevét kapja.",
    copy_zone_step5_new_zone: 'Új zóna',
    copy_zone_step5_new_project: 'Új projekt',
    copy_zone_step5_devices: 'Fényeszközök',
    copy_zone_step5_mixes: 'Spektrummixek',
    link: 'Kapcsolat',
    linked_project_status_enabled: 'Aktív',
    linked_project_status_disabled: 'Letiltva',
    linked_project_status_mapping_error: 'Hozzárendelési hiba',
    linked_project_edit_mapping: 'Hozzárendelés szerkesztése',
    linked_project_deleted_channel: 'Törölt csatorna',
    linked_project_none: 'Nincsenek szinkron linkek.',
    linked_project_count_badge: '{0} kapcsolt {0,choice,1#projekt|1<projekt}',
    linked_project_error_badge: '{0} linkelt zóna hozzárendelési hibával',
    start_project_mapping_error_title: 'Hozzárendelési hiba a szinkron-tükrözött zónákban',
    start_project_mapping_error_body:
        'Ennek a projektnek {0} szinkron-tükrözött {0,choice,1#zónájában|1<zónájában} hozzárendelési hiba van. Ha elindítja a projektet, {0,choice,1#ez a zóna|1<ezek a zónák} nem lesznek tükrözve.',
    start_project_mapping_error_fix: 'A hibát a {0} oldalon javíthatja.',
    start_project_mapping_error_zones_link: 'Zóna beállítások',
    linked_project_disable: 'Letiltás',
    linked_project_enable: 'Engedélyezés',
    linked_project_delete_title: 'Szinkron kapcsolat törlése',
    linked_project_delete_message: 'Biztosan törli ezt a szinkron kapcsolatot?',
    linked_project_deleted: 'Szinkron kapcsolat törölve.',
    linked_project_updated: 'Szinkron kapcsolat frissítve.',
    linked_project_health: '{0} / {1} csatorna hozzárendelve',
    linked_project_type_mirror: 'Tükrözött',
    linked_project_type_independent: 'Független',
    linked_project_mirror_badge: '{0} {0,choice,1#tükrözött zóna|1<tükrözött zóna}',
    linked_project_mirror_description: 'Ezek a zónák szinkronizálva vannak — a projekt indítása vagy leállítása mindegyiket érinti.',
    linked_project_independent_badge: 'Független kapcsolat: {0} zóna',
    linked_project_independent_description: 'Ez a projekt a(z) "{0}" projekt független másolata a(z) "{1}" zónában — önállóan indítható és leállítható.',
    linked_project_inline_header: '{0} kapcsolt projekt',
    linked_zone_inline_header: '{0} kapcsolt zóna',
    linked_zone_type_label: 'Típus',
    linked_zone_status_label: 'Állapot',
    linked_zone_enable_running_title: 'Szinkron kapcsolat engedélyezése',
    linked_zone_enable_running_message:
        'A(z) „{0}" projekt jelenleg fut ebben a zónában. Ha engedélyezed a kapcsolatot, tükrözni fogja a forrás projektet — az aktuális ponttól, nem az elejétől. Biztosan engedélyezed?',
    linked_zone_disable_running_title: 'Szinkron kapcsolat letiltása',
    linked_zone_disable_running_message:
        'A(z) „{0}" projekt jelenleg fut ebben a zónában. Ha letiltod a kapcsolatot, azonnal leáll, miközben a forrás projekt tovább fut. Biztosan letiltod?',
    linked_zone_independent_disable_message: '{0} projekt fut vagy szünetel ebben a kapcsolt zónában, és leáll, ha letiltod a kapcsolatot. Biztosan letiltod?',
    linked_zone_delete_running_title: 'Szinkron kapcsolat törlése',
    linked_zone_delete_running_message:
        'A(z) „{0}" projekt jelenleg fut ebben a zónában. Ha törlöd a kapcsolatot, azonnal leáll, miközben a forrás projekt tovább fut. Biztosan törlöd?',
    linked_zone_switch_type_button: 'Típus váltása',
    linked_zone_switch_to_mirror_title: 'Váltás szinkron tükörre',
    linked_zone_switch_to_mirror_running_virtual: '{0} projekt leáll a kapcsolt zónában.',
    linked_zone_switch_to_mirror_running_source: 'A forrás projekt fut — a tükrözés azonnal folytatódik.',
    linked_zone_switch_to_independent_title: 'Váltás független módra',
    linked_zone_switch_to_independent_running_source: 'A forrás projekt fut — a kapcsolt zóna elsötétül, amíg nem indítod el kézzel a projekteket.',
    project_has_independent_copies_title: 'Projekt törlése',
    project_has_independent_copies_message:
        'Ennek a projektnek {0} független zónamásolata van. A törlés az összes másolatot leállítja és törli. Biztosan törlöd?',
    copy_zone_confirm_link: 'Kapcsolat létrehozása',
    copy_zone_link_success: 'Szinkron kapcsolat sikeresen létrehozva.',
    copy_zone_link_sync_step3_description:
        'Ez a folyamat egy szinkron kapcsolatot hoz létre. A kapcsolt zóna tükrözi a forrás zóna DMX-kimenetét az új címeken.',
    copy_zone_link_independent_step3_description:
        'Ez a folyamat egy független kapcsolatot hoz létre. A kapcsolt zóna azonos programot fut, de a projektek egymástól függetlenül indíthatók és állíthatók le.',
    copy_zone_link_sync_step4_heading: 'Új DMX-címek hozzárendelése',
    copy_zone_link_sync_step4_description: 'Rendelj új DMX-címet minden fénycsatornához. Ezek a címek kapják meg a forrás zóna tükrözött DMX-jelét.',
    copy_zone_channel_name: 'Csatorna neve',
    copy_zone_original_dmx: 'Eredeti DMX',
    copy_zone_new_dmx: 'Új DMX',
    copy_zone_link_sync_step5_description:
        "A 'Kapcsolat létrehozása' gombra kattintva szinkron kapcsolat jön létre. A forrás zóna DMX-kimenete a megadott címekre kerül szétosztásra.",
    copy_zone_link_independent_step5_description:
        "A 'Kapcsolat létrehozása' gombra kattintva független kapcsolat jön létre. A forrás zóna minden projektjéhez önálló másolat készül, amelyek egymástól függetlenül indíthatók és állíthatók le.",
    copy_zone_link_name: 'Kapcsolat neve',
    copy_zone_link_channel_mapping: 'Csatorna-hozzárendelés',
    copy_link_zone: 'Zóna másolása / linkelése',
    error_loading_data: 'Az adatok betöltése sikertelen. Kérjük, próbálkozz újra.',

    add_new_disabled_no_zone: 'Válasszon zónát elemek hozzáadásához',
    add_new_spectrum_mix_button: 'Új Spektrum Mix hozzáadása',
    change: 'Módosítás',
    channel_dmx_value: 'Csatorna DMX értéke',
    current_intensity: 'Jelenlegi intenzitás',
    dark_light_recipe_description: 'Minden lámpa ki',
    dark_light_recipe_name: 'Sötét',
    detail_blue: 'Kék',
    detail_fr: 'Mély Vörös',
    detail_green: 'Zöld',
    detail_ir: 'Infravörös',
    detail_ppfd: 'PPFD',
    detail_range: 'Tartomány',
    detail_red: 'Vörös',
    detail_red_blue_ratio: 'Vörös/Kék arány',
    detail_sum: 'Összesítő',
    detail_uv: 'Ultraibolya',
    detail_uvA: 'UV-A',
    detail_uvB: 'UV-B',
    detail_uvC: 'UV-C',
    detail_visibleSum: 'Látható tartomány',
    irradiance: 'Besugárzás',
    irradiance_unit: 'W/m²',
    light_channel_move_zone_confirm:
        'Áthelyezi az eszközt a(z) {0} zónába? Eltávolítja az összes {1} spektrum mixből és hozzáadja az összes {0} spektrum mixhez. Ez nem vonható vissza.',
    light_channel_move_zone_confirm_running: 'Egy vagy több projekt jelenleg fut, és azonnal frissítve lesz.',
    light_channel_zone: 'Zóna: {0}',
    logout_successful: 'Kijelentkezve',
    socket_disconnected: 'Kapcsolat megszakadt — újracsatlakozás...',
    mix_intensity: 'Mix intenzitás:',
    no_spectrum_mix: 'Még nincs Spektrum Mix.',
    pfd: 'PFD',
    pfd_unit: 'µmol/m²/s',
    project_detailed_last_status: 'Az utolsó szekció {0} volt, {2} {1}. körforgása {3}%-on',
    project_editor_disabled_tree_selection: 'Spektrum mix hozzárendelve, zóna váltás nem lehetséges.',
    project_editor_select_spectrum_mix: 'Spektrum mix kiválasztása a(z) "{0}" Fény recepthez',
    project_is_starts_with_a_delay_within: 'A projekt késleltetéssel indul, {0} belül',
    project_linked_spectrum_mix: 'Nem választható ki, a Spektrum Mixet vagy egy benne lévő Fényeszközt a(z) "{0}" Projekt használja',
    restart_server_app: 'Szerver alkalmazás újraindítása',
    restart_server_app_button: 'Újraindítás',
    restart_server_app_confirm: 'Biztosan újraindítja a szerver alkalmazást?',
    restart_server_app_description: 'A Ledium MEC szerver folyamatának újraindítása. Az oldal automatikusan újratölt, amint a szerver visszaáll.',
    restarting_server_app: 'Újraindítás...\nEgy pillanat türelmet.\nNe frissítse az oldalt.',
    restoring_database: 'Adatbázis visszaállítása...',
    running_project_change_confirm: 'Jelenleg fut egy projekt ebben a zónában. A változások azonnal érvénybe lépnek. Folytatja?',
    search_for_spectrum_mix: 'Spektrum Mix keresése',
    select_zone_of_the_lighting_devices: 'Válassza ki a Fényeszközök zónáját ehhez a Spektrum Mixhez',
    select_zone_of_the_spectrum_mixes: 'Válassza ki a Spektrum Mixek zónáját ehhez a Projekthez',
    set_start_time: 'Kezdési idő beállítása',
    show_colors: 'Színek megjelenítése',
    spectrum_mix: 'Spektrum Mix',
    spectrum_mix_auto_mix: 'Auto Mix',
    spectrum_mix_create_light_recipe: 'Fény recept létrehozása',
    spectrum_mix_create_light_recipe_created_message: 'A(z) {0} fény recept létrejött. Szeretné ehhez a Spektrum Mixhez használni?',
    spectrum_mix_create_light_recipe_created_title: 'Fény recept létrehozva',
    spectrum_mix_create_light_recipe_exists_message: 'Már létezik egy {0} fény recept ezzel a spektrummal. Szeretné ehhez a Spektrum Mixhez használni?',
    spectrum_mix_create_light_recipe_exists_title: 'A fény recept már létezik',
    spectrum_mix_linked_light_channel_another_mix:
        'Nem választható ki, a Fényeszköz a(z) "{0}" Spektrum Mixhez tartozik, amelyhez a(z) "{1}" Projekthez kapcsolódó Fényeszköz is tartozik',
    spectrum_mix_linked_light_channel_project: 'Nem választható ki, a Fényeszközt a(z) "{0}" Projekt használja',
    spectrum_mix_linked_project: 'A Spektrum Mixet a(z) "{0}" Projekt használja, nem törölhető',
    spectrum_mix_no_light_recipe_message: 'Ennek a Spektrum Mixnek nincs Fény receptje. Szeretne egyet létrehozni ebből a spektrumból?',
    spectrum_mix_no_light_recipe_title: 'Nincs Fény recept',
    spectrum_mix_not_available: 'Nincs Spektrum Mix létrehozva egy Fény recepthez',
    spectrum_mix_not_exists: 'A párosított Spektrum Mix már nem elérhető',
    spectrum_mix_not_set: 'Egy Fény recepthez nincs párosított Spektrum Mix',
    spectrum_mix_realtime_lights: 'Valós idejű lámpák',
    spectrum_mix_realtime_lights_forced_disable: 'A valós idejű lámpák le lettek tiltva, mert egy Fényeszközt szerkesztett vagy törölt.',
    spectrum_mix_running_project: 'A Spektrum Mixet egy futó Projekt használja: {0}',
    spectrum_mix_settings_carousel_view: 'Körhinta nézet',
    spectrum_mix_settings_list_view: 'Lista nézet',
    spectrum_mix_similarity: 'Spektrális hasonlóság',
    spectrum_mixer_description: 'Spektrum Mixet készíthet az elérhető Fényeszközökkel, amely egy Fény receptet szimulál.',
    spectrum_mixer_disabled_tree_selection: 'Fényeszköz van kiválasztva, zóna váltás nem lehetséges.',
    spectrum_mixer_no_light_in_zone: 'Nincs fénycsatorna ebben a zónában. Adjon hozzá fényeszközöket a Spektrum Mix létrehozása előtt.',
    spectrum_mixer_title: 'Spektrum Mixer',
    target_spectrum_not_exists: 'A hozzáadott receptben szereplő egyik Fény recept már nem elérhető',
    test: 'Teszt',
    the_dmx_channel_is_used: 'A DMX csatorna használatban van',
    USED_IN_SPECTRUM_MIX: 'A fénycsatorna {0} Spektrum Mixben van használatban, zóna váltás nem lehetséges',
    zone_all_warning: 'Az összes zónát nézi. Új elemek hozzáadása letiltva.',
    zone_of_the_lighting_device: 'A fényeszköz zónája:',
    zone_selector_add: 'Zóna hozzáadása',
    zone_selector_edit: 'Zónák szerkesztése',
    zone_selector_hide_all: 'Összes zóna elrejtése',
    zone_selector_select: 'Zóna kiválasztása',
    zone_selector_show_all: 'Összes zóna megjelenítése',
    zone_selector_showing_all: 'Összes zóna megjelenítve',

    X_is_successfully_deleted: '{0} sikeresen törölve',
    settings_saved: 'Beállítások elmentve',
    settings_save_error: 'Beállítások mentése sikertelen',
    date_time_saved: 'Dátum és idő elmentve',
    action_failed: 'Sikertelen művelet',
    project_action_failed: 'Projekt művelet sikertelen',
    light_recipe_created: 'Fény recept létrehozva',
    zone_updated: 'Zóna frissítve',
    zone_created: 'Zóna létrehozva',
    zone_reorder_failed: 'Zóna sorrend mentése sikertelen',
    dmx_test_sent: 'DMX teszt jel elküldve',
    dmx_test_failed: 'DMX teszt sikertelen',
    all_projects_stopped: 'Minden projekt leállítva',
    section_jumped: 'Szakasz kihagyva',
    error_occurred: 'Hiba történt',
    dark_mode: 'Sötét mód',
    light_mode: 'Világos mód'
};
